const store = require("store")

const SignOut = () => {
	store.remove("site")
	store.remove("site_code")
	store.remove("user_seq")
	store.remove("site_user_seq")
	store.remove("username")
	store.remove("fullname")
	store.remove("locale")
	store.remove("access_token")
	store.remove("refresh_token")
	store.remove("user_category_code")
	store.remove("current_module_seq")
	store.remove("loggedIn")

	console.log("Sign Out Successful")
	// history.push("/signin")
	window.location.reload()
}

export default SignOut